__turbopack_context__.v({
  "container": "PriceDisplay-module__cVim8W__container",
  "current-price": "PriceDisplay-module__cVim8W__current-price",
  "installment": "PriceDisplay-module__cVim8W__installment",
  "installment-symbol": "PriceDisplay-module__cVim8W__installment-symbol",
  "strike-through": "PriceDisplay-module__cVim8W__strike-through",
});
